// extracted by css-extract-rspack-plugin
export default {"DismissibleFlashContainer":"DismissibleFlash-module__DismissibleFlashContainer__VStmCle","dismissButton":"DismissibleFlash-module__dismissButton__GEPy8Hj"};